import { Fragment } from 'react';
import Default from './default/index';

const Themes = {
    Default,
};

const Component = Themes[window.localStorage.getItem('theme') || 'Default'] || Fragment;

export default Component;
